<template>
  <el-container :key="reRender" class="wrapper">
    <el-container class="is-vertical">
      <vHeader v-if="!layoutList.includes($route.name)"></vHeader>
      <HeaderLogin v-else></HeaderLogin>
      <el-main id="elMain">
        <transition>
          <router-view></router-view>
        </transition>
        <vFooter v-if="!layoutList.includes($route.name)"></vFooter>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { apiSetlanguage } from '@/resource';
import vHeader from '@/components/Header';
import HeaderLogin from '@/components/HeaderLogin';
import vFooter from '@/components/Footer';
import { loadDownloadI18n } from '@/resource/i18n';

export default {
  name: 'layout',
  data() {
    return {
      layoutList: ['login', 'forgetPassword', 'forgetPasswordMobile', 'addAuthentication', 'verifyAuthentication'],
      reRender: 0
    };
  },
  components: { HeaderLogin, vHeader, vFooter },
  computed: {
    lang() {
      return this.$store.state.common.lang;
    }
  },
  watch: {
    lang: {
      immediate: true,
      async handler(val) {
        loadDownloadI18n(val).then(async (res) => {
          this.$i18n.locale = val;
          if (this.$store.state.common.loginStatus) await this.setUserLanguagePreference(val);
          this.reRender++;
        });
      }
    },
    reRender() {
      if (this.$route.meta.restrictReload) this.$router.push('/home');
    }
  },
  methods: {
    async setUserLanguagePreference(lang) {
      await apiSetlanguage({ language: lang });
      this.$store.dispatch('regulator/actionGetInformation');
    }
  }
};
</script>

<style lang="scss">
@import '@/assets/css/app.scss';
.v-leave {
  opacity: 1;
}
.v-leave-active {
  transition: opacity 0.5s;
}
.v-leave-to {
  opacity: 0;
}
.v-enter {
  opacity: 0;
}
.v-enter-active {
  transition: opacity 0.2s;
}
.v-enter-to {
  opacity: 1;
}
@import '../../assets/Oblivian-Regular/stylesheet.css';
@import '../../assets/NotoSansCJKJapanese-hinted/stylesheet.css';
@import '../../assets/NotoSansCJKKorean-hinted/stylesheet.css';
@import '../../assets/NotoSansCJKSimChinese-hinted/stylesheet.css';
@import '../../assets/NotoSans-hinted/stylesheet.css';
@import '../../assets/NotoSans-Bold/stylesheet.css';
@import '../../assets/NotoSansThaiLooped/stylesheet.css';
</style>
